import React, { useEffect } from "react";

import { Link, withRouter } from "react-router";

import { Form, Field } from "react-final-form";

import { Subscribe } from "unstated";

import { SetupContainer } from "./containers/setup-container";

import { FORM_ERROR } from "final-form";

import { TextInput } from "./ui/text-input";
import { FormErrors } from "./ui/form-errors";

import { PasswordToggle } from "./ui/password-toggle";

import navigation from "../lib/navigation-utilities";

import _ from "lodash";

import {
  required,
  email,
  maxLength,
  phone,
  nonEmptyString,
  date,
  composeField
} from "../lib/form-validators";

import { phoneFormatter } from "../lib/form-formatters";
import { phoneParser } from "../lib/form-parsers";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import PublicPage from "./public-page";

const AccountSetup = (props) => {
  return (
    <Subscribe to={[SetupContainer]}>
      {(setupContainer) => (
        <AccountSetupContainer {...props} setupContainer={setupContainer} />
      )}
    </Subscribe>
  );
};

const AccountSetupContainer = ({ params, setupContainer }) => {
  useEffect(() => {
    setupContainer.lookupExistingProfile(params.setupToken).catch((error) => {
      navigation.push("/");
    });
  }, []);

  const onSubmit = async (values) =>
    setupContainer
      .activate(params.setupToken, values)
      .then((result) => {
        navigation.push("/");
      })
      .catch((error) => {
        return { [FORM_ERROR]: "Failed activate account" };
      });

  const existingInfo = setupContainer.getExistingInfo();

  if (!existingInfo)
    return (
      <PublicPage>
        <div className="content text-center align-items-center" />
      </PublicPage>
    );

  return (
    <PublicPage>
      <div className="content text-center align-items-center">
        <Form
          initialValues={existingInfo || {}}
          onSubmit={onSubmit}
          render={({
            handleSubmit,
            submitting,
            submitError,
            dirtySinceLastSubmit
          }) => (
            <form onSubmit={handleSubmit}>
              <Field
                inputClass="dc-login_input"
                name="email"
                validate={composeField(required, email, maxLength(256))}
                render={TextInput}
                placeholder="EMAIL"
                prependValue={
                  <div className="dc-login_icon">
                    <FontAwesomeIcon
                      icon={["fas", "envelope"]}
                      size="sm"
                      color="#69717a"
                    />
                  </div>
                }
              />
              <Field
                inputClass="dc-login_input"
                name="password"
                validate={composeField(required)}
                render={TextInput}
                placeholder="PASSWORD"
                type="password"
                prependValue={
                  <div className="dc-login_icon">
                    <FontAwesomeIcon
                      icon={["fas", "lock"]}
                      size="sm"
                      color="#69717a"
                    />
                  </div>
                }
                appendValue={(input) => <PasswordToggle inputRef={input} />}
              />

              <Field
                name="password_confirmation"
                inputClass="dc-login_input"
                validate={composeField(required)}
                render={TextInput}
                placeholder="CONFIRM PASSWORD"
                type="password"
                prependValue={
                  <div className="dc-login_icon">
                    <FontAwesomeIcon
                      icon={["fas", "lock"]}
                      size="sm"
                      color="#69717a"
                    />
                  </div>
                }
                appendValue={(input) => <PasswordToggle inputRef={input} />}
              />

              <Field
                name="firstName"
                inputClass="dc-login_input"
                validate={composeField(nonEmptyString, maxLength(64))}
                render={TextInput}
                placeholder="FIRST NAME"
                type="text"
              />

              <Field
                name="lastName"
                inputClass="dc-login_input"
                containerStyle="form-group input-group"
                validate={composeField(nonEmptyString, maxLength(64))}
                render={TextInput}
                placeholder="LAST NAME"
                type="text"
              />

              <Field
                name="homePhoneNumber"
                inputClass="dc-login_input"
                validate={composeField(phone)}
                format={phoneFormatter}
                parse={phoneParser}
                formatOnChange={true}
                render={TextInput}
                placeholder="HOME PHONE NUMBER"
                type="tel"
                prependValue={
                  <div className="dc-login_icon">
                    <FontAwesomeIcon
                      icon={["fas", "phone"]}
                      size="sm"
                      color="#69717a"
                    />
                  </div>
                }
              />

              <Field
                name="dateOfBirth"
                containerStyle="mb-5"
                inputClass="dc-login_input"
                validate={composeField(required, date)}
                render={TextInput}
                placeholder="DATE OF BIRTH"
                type="date"
                caption="* I am at least 21 years of age"
              />

              <FormErrors
                submitError={submitError}
                dirtySinceLastSubmit={dirtySinceLastSubmit}
              />

              <button
                type="submit"
                className="btn btn-primary btn-xl w-100 text-uppercase"
                disabled={submitting}>
                Complete Setup
              </button>
            </form>
          )}
        />
      </div>
      <div className="footer text-center mt-5">
        <Link className="text-uppercase" to="/">
          Login
        </Link>
      </div>
    </PublicPage>
  );
};

export default withRouter(AccountSetup);
